import { SVGProps, Ref, forwardRef } from 'react';

export const HyperstarFilledSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 0c4 6 10 12 16 16-6 4-12 10-16 16-4-6-10-12-16-16C6 12 12 6 16 0"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
HyperstarFilledSize32Glyph.displayName = 'HyperstarFilledSize32Glyph';
